module.exports = __webpack_public_path__ + "img/折叠.f811a0db.svg";